import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_Passed extends QuestionPassState {
    id = QuestionPassStateId.Passed;
    name = 'Richtig beantwortete Fragen';
    color = 'success';
    orderInProgressbar = 3;
    isDefaultFiltered = true;
}
